
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2023
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Progetto Gemini',
	'appExit': 'Vai alla pagina di benvenuto',


	'widgetsListLabel': 'Elenco dei widget. Selezionare un widget e premere Invio per aggiungere.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Aggiornato',
	'dirty': 'Non aggiornato',
	'conflict': 'Conflitto durante il salvataggio della vista',
	'error': 'Problema durante il salvataggio della vista',
	'failure': 'Impossibile contattare il server',
	'saveFailed': 'Impossibile salvare la vista',

	'wa_insync': 'Salvato',
	'wa_conflict': 'Conflitto durante il salvataggio della vista',
	'wa_error': 'Impossibile salvare la vista',
	'wa_failure': 'Impossibile contattare il server',

	// Menu Labels
	'changeDisplay': 'Modifica visualizzazione',
	'changeToColumnChart': 'Passa a istogramma',
	'changeToBubbleChart': 'Passa a grafico a bolle',
	'toggleMoveHandles': 'Attiva/disattiva barre di spostamento',
	'undo': 'Annulla',
	'redo': 'Ripeti',
	'mode': 'Cambia modalità',

	'untitled': 'Senza titolo',
	'remove': 'Rimuovi',
	'editTitle': 'Modifica il titolo',
	'edit': 'Modifica',
	'done': 'Fine',

	// Data tray
	'dataTrayHandleOpenLabel': 'Apri livello dati',
	'dataTrayHandleCloseLabel': 'Chiudi livello dati',

	// Dialogs
	'dlg_loading': 'Caricamento in corso...',
	'dlg_ok': 'OK',
	'dlg_create': 'Crea',
	'dlg_cancel': 'Annulla',
	'dlg_close': 'Chiudi',
	'dlg_update': 'Aggiorna',
	'dlg_renameBoardTitle': 'Ridenomina questo oggetto',
	'dlg_renameDatasetTitle': 'Ridenomina questo dataset',
	'dlg_renameSceneTitle': 'Rinomina questa scena',
	'dlg_NameLabel': 'Nome:',
	'dlg_NewNameLabel': 'Nuovo nome:',
	'dlg_DefaultNameWithDataSet': 'Vista %{name} ',
	'dlg_ShareTitle': 'Condividi contenuto',
	'dlg_UnshareTitle': 'Rimuovi condivisione contenuto',
	'dlg_ShareUser': 'ID utente:',
	'dlg_NewColumnLabel': 'Nuovo nome calcolo',

	'dlg_new': 'Nuovo...',
	'dlg_open': 'Apri...',
	'dlg_makeACopy': 'Crea una copia',
	'dlg_rename': 'Ridenomina...',
	'dlg_moreToCome': 'Altre azioni in arrivo...',

	'dlg_use': 'Utilizza',

	'dlg_RelinkDatasetTitle': 'Sostituire il dataset \'%{datasetName}\' con ...',

	'open_error': 'Si è verificato un problema nell\'apertura della vista.',

	// Delete Board
	'del_dialogTitle': 'Conferma eliminazione',
	'del_itemMsg': 'Si è sicuri di voler eliminare \'%{name}\'?',
	'del_itemsMsg': 'Sicuri di voler eliminare %{count} elementi?',
	'del_deleteErr': 'Impossibile eliminare \'%{name}\'',

	// List Sorting
	'dlg_ascending': 'ascendente',
	'dlg_descending': 'discendente',
	'dlg_custom': 'personalizzato',
	'dlg_none': 'nessuno',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Ricerca',

	'searchHint': 'Ricerca tutti i dati personali',
	'clearSearchResult': 'Cancella risultati della ricerca',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'Cerchio',
	'shapesHexagon': 'Esagono',
	'shapesLine': 'Riga',
	'shapesOctagon': 'Ottagono',
	'shapesPentagon': 'Pentagono',
	'shapesSquare': 'Quadrato',
	'shapesTriangle': 'Triangolo',
	'shapesDiamond': 'Rombo',
	'shapesTitle': 'Proprietà forma', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'Quadrato arrotondato',
	'shapesStar': 'Stella',
	'shapesChevron': 'Parentesi angolare',
	'shapesBadge_ribbon': 'Icona badge',
	'shapesBadge': 'Badge',
	'shapesHeart': 'Cuore',
	'shapesExclamation': 'Esclamazione',
	'shapesTrendingup': 'Andamento positivo',
	'shapesTrendingdown': 'Andamento negativo',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Persone',
	'shapesFemale': 'Femmina',
	'shapesHappyface': 'Faccia felice',
	'shapesMale': 'Maschio',
	'shapesMan': 'Uomo',
	'shapesNeutralface': 'Senza espressione',
	'shapesSadface': 'Faccia triste',
	'shapesShakehands': 'Stretta di mano',
	'shapesThumbsdown': 'Pollice verso',
	'shapesThumbsup': 'Pollice in alto',
	'shapesWoman': 'Donna',

	// Weather and places
	'shapesPlacesWeatherCat': 'Posti & meteo',
	'shapesCity': 'Città',
	'shapesCloud': 'Nuvola',
	'shapesEducation': 'Formazione',
	'shapesGovernment': 'Governo',
	'shapesHalfcloud': 'Mezza nuvola',
	'shapesHouse': 'Casa',
	'shapesMoon': 'Luna',
	'shapesRain': 'Piovoso',
	'shapesSunny': 'Soleggiato',

	//Vehicles
	'shapesVehiclesCat': 'Veicoli',
	'shapesAirplane': 'Aeroplano',
	'shapesCar': 'Auto',
	'shapesShip': 'Nave',
	'shapesShoppingcart': 'Carrello degli acquisti',
	'shapesTrain': 'Treno',
	'shapesTruck': 'Camion',

	//Objects
	'shapesObjectsCat': 'Oggetti',
	'shapesBook': 'Libro',
	'shapesBriefcase': 'Valigetta',
	'shapesCalendar': 'Calendario',
	'shapesCheck': 'Assegno',
	'shapesClock': 'Orologio',
	'shapesDesktop': 'Desktop',
	'shapesDocument': 'Documento',

	'shapesFood': 'Cibo',
	'shapesGear': 'Ingranaggio',
	'shapesHealth': 'Sanità',

	'shapesIdea': 'Idea',
	'shapesMobile': 'Mobile',
	'shapesMoney_bill': 'Banconota',
	'shapesMoney_coin': 'Moneta',
	'shapesPiggybank': 'Salvadanaio',
	'shapesStackofpaper': 'Pila di carta',
	'shapesStickynote1': 'Post-it 1',
	'shapesStickynote2': 'Post-it 2',
	'shapesTarget': 'Destinazione',
	'shapesTool': 'Strumento',

	'shapesUmbrella': 'Ombrello',

	'shapesBrain': 'Cervello',
	'shapesSkull': 'Teschio',
	'shapesEye': 'Occhio',

	// Arrows shapes
	'shapesArrowsCat': 'Frecce',
	'shapesRightArrow': 'Freccia a destra',
	'shapesLeftArrow': 'Freccia a sinistra',
	'shapesDoubleArrow': 'Doppia freccia',
	'shapesCurvedArrow': 'Freccia curva',

	// Callouts shapes
	'shapesCalloutsCat': 'Callout',
	'shapesRectCallout': 'Callout',

	// Images
	'imagesCat': 'Immagini',
	'imageWidgetTitle': 'Immagine del widget',
	'imgUrl': 'URL immagine',
	'noImgSelected': 'Nessuna immagine selezionata ',
	'enterImgUrl': 'Inserire qui l\'URL dell\'immagine',
	'imgPasteLink': 'Incollare l\'URL e premere Invio per salvarlo.',
	'imgResizeToFit': 'Ridimensiona per adattare la dimensione dell\'immagine',
	'imgHeight': 'Altezza:',
	'imgWidth': 'Larghezza:',
	'imgTransparency': 'Trasparenza:',
	'imgMissingUrl': 'Manca l\'URL dell\'immagine.',
	'imgUrlValidationError': 'L\'URL dell\'immagine non è valido.',
	'imgUrlInvalidDomainError': 'L\'url immagine punta ad un dominio che non è stato approvato dall\'amministratore. I domini approvati dall\'amministratore sono "%{domains}".',
	'notPositiveNumberError': 'Solo valori positivi',

	// line shape
	'propStrokeWidth': 'Spessore linea',
	'propStrokeDashArray': 'Stile linea',
	'propStrokeSolidline': 'Linea continua',
	'propStrokeLineCap': 'Cap linea',
	'propStrokeLineCapButt': 'Estremità',
	'propStrokeLineCapRound': 'Tondo',
	'propStrokeLineCapSquare': 'Quadrato',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Riproduci',
	'dataPlayerValueListLabel': 'Valori Data player',
	// Text Widget
	'textWidgetTitle': 'Widget di testo',
	'textStyle': 'Stili',
	'textStyleDescription': 'Stili testo preformattato',
	'textTitleStyle': 'Titolo',
	'textTitleSmallStyle': 'Titolo piccolo',
	'textSubtitleStyle': 'Sottotitolo',
	'textBodyStyle': 'Corpo',
	'textBodySmallStyle': 'Corpo piccolo',
	'textCaptionStyle': 'Didascalia',
	'textQuoteStyle': 'Virgolette',
	'textQuoteSmallStyle': 'Virgolette piccole',
	'textResponsiveStyle': 'Dimensionamento automatico',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Sottile',
	'textFontFamilySubClassThin': 'Sottile',
	'textFontFamilySubClassThinItalic': 'Corsivo sottile',
	'textFontFamilySubClassExtraLight': 'Chiarissimo',
	'textFontFamilySubClassExtraLightItalic': 'Corsivo chiarissimo',
	'textFontFamilySubClassLight': 'Chiaro',
	'textFontFamilySubClassLightItalic': 'Corsivo chiaro',
	'textFontFamilySubClassRegular': 'Regolare',
	'textFontFamilySubClassRegularItalic': 'Corsivo regolare',
	'textFontFamilySubClassItalic': 'Corsivo',
	'textFontFamilySubClassMedium': 'Medio',
	'textFontFamilySubClassMediumItalic': 'Corsivo medio',
	'textFontFamilySubClassHeavy': 'Pesante',
	'textFontFamilySubClassHeavyItalic': 'Corsivo pesante',
	'textFontFamilySubClassDemiBold': 'Mezzo grassetto',
	'textFontFamilySubClassDemiBoldItalic': 'Corsivo mezzo grassetto',
	'textFontFamilySubClassBold': 'Grassetto',
	'textFontFamilySubClassBoldItalic': 'Corsivo grassetto',
	'textFontFamilySubClassExtraBold': 'Grassetto scuro',
	'textFontFamilySubClassExtraBoldItalic': 'Corsivo scuro',
	'textFontFamilySubClassBlack': 'Nero',
	'textFontFamilySubClassBlackItalic': 'Corsivo nero',
	'textFontFamilySubClassStencil': 'Stencil',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'Dimensionamento automatico carattere',
	'responsiveCoachmarkContents': 'La dimensione del carattere viene automaticamente adattata quando questo tipo di testo viene ridimensionato. È possibile impostare le dimensioni del carattere nelle proprietà del testo.',

	'propText': 'Dettagli testo', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'Proprietà testo', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'Dimensione carattere',
	'textFontFamily': 'Famiglia di caratteri',
	'textFontWeight': 'Spessore carattere', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'textFontColor': 'Colore',
	'textLineHeight': 'Altezza riga',
	'textIndentation': 'Rientro',
	'textIncreaseIndentation': 'Aumenta rientro',
	'textDecreaseIndentation': 'Diminuisci rientro',
	'textInnerMargins': 'Margini interni (px)',

	// Widget Properties
	'propImageLink': 'Collegamento immagine',
	'propMissingURL': 'Immetti URL',
	'propImgTop': 'Proprietà immagine', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'Proprietà generali', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'Generale', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'Generale', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'Colore riempimento', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'Colore testo', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propBorderColor': 'Colore bordo',
	'propBorderRadius': 'Raggio d\'angolo (px)',
	'propShowBorderInPreview': 'Mostra bordo selezionato in anteprima',
	'propMaintainAxisScales': 'Conserva scala asse',
	'propShowItemLabel': 'Mostra etichetta elemento',
	'propHideLegend': 'Nascondi legenda',
	'propColorPalette': 'Tavolozza',
	'propLegendPosition': 'Posizione legenda',
	'propHideAxisTitleLabels': 'Nascondi titoli assi',
	'propLineColor': 'Colore linea',
	'propBubbleColor': 'Colore bolla',
	'propInterpolation': 'Linee smussate',
	'propElementColor': 'Colore elemento di visualizzazione',
	'propSymbolShape': 'Forma simbolo',
	'propHeatScalePalette': 'Ordine colori',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'I colori più scuri rappresentano i valori più piccoli.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'I colori più scuri rappresentano i valori più grandi.',
	'propImageDetails': 'Dettagli immagine', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Dettagli pagina Web', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'Dettagli supporti', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'Inserire l\'URL e premere Invio.',

	//Layout Properties
	'sectionName_positionAndStyle': 'Posizione & stile',
	'propPositionLabel': 'Posizione', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis_v1': 'X',
	'propPositionXAxis': 'Posizione X (%{unit})',
	'propPositionYAxis_v1': 'Y',
	'propPositionYAxis': 'Posizione Y (%{unit})',
	'propResizeLabel': 'Dimensione', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth_v1': 'Larghezza',
	'propResizeWidth': 'Larghezza (%{unit})',
	'propResizeHeight_v1': 'Altezza',
	'propResizeHeight': 'Altezza (%{unit})',
	'propRotateLabel_v1': 'Ruota',
	'propRotateLabel': 'Rotazione (°)',
	'propRotateAngle': 'Angolo', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Quantità di icone',
	'propScaleDescription': 'Selezionare le quantità di icone',
	'propScaleFew': 'Basso',
	'propScaleDefault': 'Impostazione predefinita',
	'propScaleMany': 'Alto',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'Questo valore deve essere numerico',

	'mediaAriaLabel': 'url di input',
	'dropdownAriaLabel' : 'Elenco a discesa ',
	'ariaGroupLabel': 'Categoria elenco a discesa: %{cateoryLabel} elemento: %{itemLabel}. Premere il tasto GIU\' per espandere. Premere i tasti SU e GIU\' per navigare oppure il tasto ESCAPE per comprimere.',
	'colorNoFillLabel': 'Nessun riempimento',
	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Ultimo aggiornamento: %{timeInterval} fa',
	'widgetTimer': 'Timer del widget',

	// Theme colors
	'transparent': 'Nessun colore',
	'white': 'Bianco',
	'lightGrey': 'Grigio chiaro',
	'grey': 'Grigio',
	'darkGrey': 'Grigio scuro',
	'black': 'Nero',
	'lightBlue': 'Blu chiaro',
	'blue': 'Blu',
	'darkBlue': 'Blu scuro',
	'yellow': 'Giallo',
	'orange': 'Arancione',
	'lime': 'Verde limone',
	'green': 'Verde',
	'peach': 'Rosa pesca',
	'red': 'Rosso',
	'violet': 'Viola chiaro',
	'aqua': 'Azzurro',
	'purple': 'Viola',
	'plum': 'prugna',
	'gray10': 'Grigio 10',
	'gray20': 'Grigio 20',
	'gray30': 'Grigio 30',
	'gray50': 'Grigio 50',
	'gray60': 'Grigio 60',
	'gray70': 'Grigio 70',
	'gray80': 'Grigio 80',
	'gray90': 'Grigio 90',
	'gray100': 'Grigio 100',
	'blue50': 'Blu 50',
	'blue60': 'Blu 60',
	'blue70': 'Blu 70',
	'green40': 'Verde 40',
	'green50': 'Verde 50',
	'red50': 'Rosso 50',
	'red60': 'Rosso 60',


	//Theme Palette Labels
	'themeLabel': 'Tema',
	'paletteLabel': 'Tavolozza IBM %{number}',
	'heatPaletteLabel': 'Tavolozza di calore IBM %{number}',
	'conditionalPaletteLabel': 'Tavolozza condizionale IBM %{number}',
	'carbonPaletteXLight': 'Carbon X chiaro',
	'carbonPaletteXDark': 'Carbon X scuro',
	'carbonPalettePurple': 'Viola',
	'carbonPaletteTeal': 'Verde acqua ',
	'carbonPaletteCyan': 'Ciano ',
	'carbonPaletteMagenta': 'Magenta',
	'carbonPalettePurpleTeal': 'Viola verde acqua ',
	'carbonPaletteCyanMagenta': 'Ciano magenta ',
	'carbonPaletteGreenRed': 'Verde rosso',
	'carbonPaletteGreenYellowRed': 'Verde giallo rosso',
	'carbonPalettePurpleTealConvergent': 'Viola verde acqua convergente ',
	'carbonPaletteCyanMagentaConvergent': 'Ciano magenta convergente ',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'Tavolozza chiara IBM',
	'userPaletteColor_defaultTheme': 'Tavolozza predefinita IBM',
	'userPaletteColor_darkTheme': 'Tavolozza scura IBM',

	// Dashboard
	'propDashboardBackgroundColor': 'Colore di sfondo',
	'propLayoutPositioning': 'Posizionamento layout',
	'propLayoutRelative': 'Relativo',
	'propLayoutAbsolute': 'Assoluto',
	'propLayoutPositioningCoachmarkTitle': 'Selezionare uno stile di layout',
	'propLayoutPositioningCoachmarkContent': 'In un layout relativo, la dimensione e la posizione dei widget vengono adattate in base allo schermo. In un layout assoluto, i widget vengono visualizzati esattamente con le dimensioni e nella posizione impostate nella vista, indipendentemente dalla dimensione dello schermo.',
	'gridText': 'Mostra griglia',
	'snapText': 'Blocca sulla griglia',
	'snapObjectsText': 'Blocca sugli oggetti',
	'fitPageText': 'Adatta pagina',
	'gridLabel': 'Griglia',
	'heightUnit': 'h',
	'widthUnit': 'w',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Dimensione pagina',
	'propPageSizePresetAriaLabel': 'Preimpostazione dimensione pagina',
	'propPageSizePreset_v1': 'Preimpostato',
	'propPageSizePreset': 'Dimensione pagina',
	'propPageSizePresetCustom': 'Personalizzato',
	'propPageSizePreset16x9': 'Schermo 16:9',
	'propPageSizePreset4x3': 'Schermo 4:3',
	'propPageSizePresetInfographic': 'Infografica',
	'propPageSizeWidth_v1': 'Larghezza',
	'propPageSizeWidth': 'Larghezza (pixel)',
	'propPageSizeHeight_v1': 'Altezza',
	'propPageSizeHeight': 'Altezza (pixel)',
	'propPageSizeWidthAriaLabel': 'Larghezza dimensione pagina',
	'propPageSizeHeightAriaLabel': 'Altezza dimensione pagina',
	'propPageSizeAdjustedMessage': 'La dimensione della pagina è stata aumentata perché l\'immissione ere inferiore al valore minimo o non si adattava al dashboard.',
	'propTabShow': 'Mostra schede',
	'propShowTabsInPreview': 'Mostra le schede in anteprima',
	'multilingualDashboardsLabel': 'Lingue',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Predefinito',
	'multilingualDashboardsAddLinkText': 'Aggiungi altra lingua',
	'multilingualDashboardsSelect': 'Seleziona',
	'multilingualDashboardsButtonLabel': 'Aggiungi',
	'multilingualDashboardTranslationMode': 'Ora sei in modalità traduzione  (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Fine',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} conversioni rimanenti',
	'multilingualDashboardRemainingString': '1 conversione rimanente',
	'multilingualDashboardsSetDefault': 'Imposta lingua predefinita',
	'multilingualDashboardIconMore': 'Più azioni per la lingua %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Area traducibile',
	'multilingualDeleteTitle': 'Elimina lingua',
	'multilingualDeleteLanguageWarning': 'Si è sicuri di voler eliminare la lingua \'%{language}\'?',
	'multilingualSelectLanguage': 'Selezionare una lingua',
	'confirmLayoutStyleUpgradeTitle': 'Applica a tutte le schede',
	'confirmLayoutStyleUpgrade': 'Applicare questo stile di layout a tutte le schede nel dashboard?',
	'defaultBackgroundColorLabel': 'Impostazione predefinita',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'Elimina',
	'tabDeleteDialogTitle': 'Eliminare questa scheda?',
	'tabDeleteDialogMessage': 'Verranno eliminati anche tutti i contenuti di questa scheda.',

	// Vis widget
	'propVisTypeReturn': 'Tipi di visualizzazione',
	'propVisDetails': 'Dettagli',

	// Alignment picker
	'propAlignPickTop': 'Allinea in alto',
	'propAlignPickRight': 'Allinea a destra',
	'propAlignPickBottom': 'Allinea in basso',
	'propAlignPickLeft': 'Allinea a sinistra',
	'propAlignPickCenter': 'Allinea al centro',
	'propAlignPickMiddle': 'Allinea al centro',
	'propAlignPicker': 'Allineamento orizzontale',
	'propVerticalAlignPicker': 'Allineamento verticale',

	// Toolbar picker
	'propToolbarPickBold': 'Grassetto',
	'propToolbarPickUnderline': 'Sottolineato',
	'propToolbarPickItalic': 'Corsivo',
	'propToolbarPickJustifyLeft': 'Allinea a sinistra',
	'propToolbarPickJustifyCenter': 'Allinea al centro',
	'propToolbarPickJustifyRight': 'Allinea a destra',
	'propToolbarPickJustify': 'Giustifica',

	'propList': 'Elenco',
	'propOrderedList': 'Elenco ordinato',
	'propUnorderedList': 'Elenco non ordinato',

	// Symbol shapes
	'propCircle': 'Cerchio',
	'propTriangle': 'Triangolo',
	'propSquare': 'Quadrato',
	'propRect': 'Rettangolo',
	'propStar': 'Stella',
	'propCross': 'Croce',
	'propPlus': 'Più',
	'propPoly': 'Poligono',


	// True and false selection
	'propTrue': 'True',
	'propFalse': 'False',

	// Position selection
	'propLeft': 'Sinistra',
	'propRight': 'Destra',
	'propTop': 'In alto',
	'propBottom': 'In basso',

	// Interpolation options
	'propSmooth': 'Smussata',
	'propStraight': 'Retta',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Elenco', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Sposta a sinistra', // screen reader
	'srWidgetMoveUp': 'Sposta su', // screen reader
	'srWidgetMoveRight': 'Sposta a destra', // screen reader
	'srWidgetMoveDown': 'Sposta giù', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Aumenta la dimensione proporzionalmente', // screen reader
	'srWidgetResizeSmaller': 'Diminuisci la dimensione proporzionalmente', // screen reader
	'srWidgetResizeBiggerV': 'Aumenta la dimensione verticalmente', // screen reader
	'srWidgetResizeSmallerV': 'Diminuisci la dimensione verticalmente', // screen reader
	'srWidgetResizeBiggerH': 'Aumenta la dimensione orizzontalmente', // screen reader
	'srWidgetResizeSmallerH': 'Diminuisci la dimensione orizzontalmente', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Ruota in senso orario', // screen reader
	'srWidgetRotateCCW': 'Ruota in senso antiorario', // screen reader

	// Recommended types
	'visChange': 'Visualizzazione modifica',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Visualizzazione',
	'chartLabel': 'Grafico %{chartName} ',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Premere F12 per navigare all\'interno del widget',
	'f10KeyDescription': 'Premere F10 per avviare la vista attiva del widget',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} con valore %{value}',

	'shapeColorLabel': 'Colore forma',
	'showLegendLabel': 'Mostra legenda',

	//Webpage
	'webpageWidgetTitle': 'Widget Pagina Web',
	'webpagePasteLink': 'Incollare l\'URL e premere Invio per salvarlo.',
	'propWebpageLink': 'URL della pagina Web',
	'propWebpageTitle': 'Titolo della pagina Web',
	'propWebpageTitleDescription': 'Titolo della pagina Web',
	'webpageUrl': 'URL Webpage',
	'noWebpageSelected': 'Nessuna pagina web selezionata',
	'enterWebpageUrl': 'Inserire qui l\'URL della pagina Web',
	'propWebpageTop': 'Proprietà pagina Web', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'Manca l\'URL della pagina web.',
	'webpageUrlValidationError': 'L\'URL della pagina web non è valido.',
	'webpageHttpValidationError': 'È necessario accedere alla pagina Web utilizzando un collegamento HTTPS . ',
	'webpageInvalidDomainError': 'L\'URL della pagina web sta puntando ad un dominio che non è stato approvato dall\'amministratore. I domini approvati dall\'amministratore sono "%{domains}".',

	//VizState
	'vzErrorLoading': 'Impossibile aprire la visualizzazione',
	'vzErrorLoadingMissingData': 'Impossibile aprire la visualizzazione, dati contesto mancanti',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Widget Supporti',
	'mediaPasteLink': 'Incollare l\'URL e premere Invio per salvarlo.',
	'mediaUrl': 'URL del supporto',
	'noMediaSelected': 'Nessun supporto selezionato',
	'enterMediaUrl': 'Immettere qui l\'URL del supporto',
	'videoHeight': 'Altezza:',
	'videoWidth': 'Larghezza:',
	'propMediaLink': 'Collegamento supporti',
	'propMediaTitle': 'Titolo supporti',
	'propMediaTitleDescription': 'Titolo del supporto',
	'propMediaTop': 'Proprietà supporti', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'Manca l\'URL del link del supporto',
	'mediaUrlValidationError': 'L\'URL del file del supporto non è valido.',
	'mediaUnknownValidationError': 'Questo tipo di supporto non è supportato.',
	'mediaHttpValidationError': 'È necessario accedere al file del supporto utilizzando un collegamento HTTPS.',
	'mediaInvalidDomainError': 'L\'URL dei file supporto sta puntando ad un dominio che non è stato approvato dall\'amministratore. I domini approvati dall\'amministratore sono "%{domains}".',

	// Properties pane
	'commonPropertiesLabel': 'Proprietà', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'Dataset',
	'dataViewsLabel': 'Visualizza',
	'columnQuality': 'Qualità dei dati',
	'columnProperties': 'Proprietà dei dati',

	'dataQuality': 'Qualità dei dati',
	'dataQualityRowCount': 'Numero di righe',
	'dataQualityDistribution': 'Distribuzione',
	'dataRowLabel': 'Dati',

	// Modelling UI
	'typeColumn': 'Tipo',
	'modellingColumnType': 'Tipo',
	'modellingColumnAggregation': 'Aggregazione',
	'modellingColumnUsage': 'Utilizzo',
	'modellingColumnSort': 'Ordinamento',
	'modellingColumnFormat': 'Formato',
	'modellingColumnCategory': 'Categoria',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Caricamento in corso...',

	'modellingProcessing': 'Elaborazione in corso...',
	'modellingImport': 'Importa',
	'modellingReimport': 'Reimporta',
	'modellingDatasourceTitle': 'Origine dati',
	'modellingImportStartedTitle': 'Importazione avviata',
	'modellingImportStartedText': 'L\'importazione dei dati potrebbe richiedere tempo.\n\n(Può essere creata una vista mentre i dati vengono importati).',
	'importDatasourceTitle': 'Connessioni',
	'dropHere': 'Rilascia in questo punto per creare una nuova origine dati...',
	'browseButton': 'Sfoglia',
	'errorNoData': 'Nessun dato da elaborare.',
	'errorNoFile': 'Nessun file da caricare.',
	'errorUploadFailed': 'Impossibile caricare.',
	'uploadSucceessful': 'Caricamento riuscito',
	'del_datasourceTitle': 'Elimina dataset',
	'del_datasourceMsg': 'Si è sicuri di voler eliminare \'%{name}\'?',
	'modellingFileUpdate': 'Aggiorna',
	'modellingFileUpdateTitle': 'Aggiorna dataset',
	'modellingFileUpdateDescription': 'Si è sicuri di voler aggiornare \'%{name}\'?',
	'modellingFileUpdatingTitle': 'Aggiornamento di \'%{name}\'',
	'modellingUpdateStartedTitle': 'Importazione di aggiornamento avviata',
	'modellingUpdateStartedText': 'L\'aggiornamento dei dati potrebbe richiedere tempo.\n\n(Può essere creata una vista mentre i dati vengono aggiornati.)',
	'modellingErrorImportUploadNoFile': 'Nessun file da caricare.',
	'modellingErrorImportUploadFailed': 'Impossibile caricare.',
	'modellingErrorImportUploadInvalidType': 'Il tipo di file non è valido.',
	'modellingErrorImportUploadTableFailed': 'Impossibile acquisire le tabelle.',
	'modellingIntentResultsTitle': 'Seleziona il dataset proposto per l\'utilizzo',
	'modellingColumnViewRelationships': 'Visualizza tabelle correlate',
	'modellingTableRelatedTables': 'Tabelle relative a \'%{name}\'',
	'modellingTable': '%{name} - Tabella',
	'modellingColumnIncludedInDataSet': 'Aggiunto',
	'modellingDataSet': 'Dataset',
	'modellingViewInDataSet': 'Visualizza nel dataset',
	'modellingViewRelatedTables': 'Visualizza correlate',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Nessuna tabella correlata trovata',

	'modellingValidatingDataset': 'Convalida in corso...',
	'datasetFinishedRefreshing': 'Il data set %{datasetName} è stato aggiornato. ',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Risolvi percorso di unione:',
	'modellingJoinColumns': 'Definire un percorso di unione per la tabella: %{name}',
	'modellingJoinToTable': 'Unisci a tabella: %{name}',

	// Data Quality
	'excluded': 'Escluso',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Filtro',
	'modellingColumnSortNone': 'Cancella ordinamento',
	'modellingColumnSortAsc': 'Ordine crescente',
	'modellingColumnSortDesc': 'Ordine decrescente',
	'modellingColumnRemove': 'Rimuovi questa colonna',

	// Import File Browser
	'dropboxPageTitle': 'Nuova connessione Dropbox',
	'sizeColumn': 'Dimensione',

	//Modelling Column Property Values
	'dataType_string': 'Stringa',
	'dataType_date': 'Data',
	'dataType_integer': 'Intero',
	'dataType_double': 'Doppio',
	'dataType_float': 'Mobile',
	'dataType_boolean': 'Booleano',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Conteggio',
	'defaultAggregation_countdistinct': 'Conteggio distinto',
	'defaultAggregation_max': 'Massimo',
	'defaultAggregation_min': 'Minimo',
	'defaultAggregation_avg': 'Media',
	'defaultAggregation_sum': 'Somma',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',

	'type_fact': 'Fatto',
	'type_attribute': 'Attributo',

	'defaultSort_none': 'Non ordinare',
	'defaultSort_asc': 'Ordine crescente',
	'defaultSort_desc': 'Ordine decrescente',

	'category_none': 'Nessuna',
	'category_location': 'Ubicazione',
	'category_monetary': 'Monetario',
	'category_time': 'Ora',

	// Root menu
	'rootMenuTitle': 'Menu principale',

	'errorMessageTitle': 'Errore',
	'errorMessageDetails': 'Dettagli: ',
	'errorMessageTitleAssetAlreadyExists': 'La risorsa già esiste',

	'defaultTabTitle': 'Scheda %{index}',
	'tabAddBtnTitle': 'Aggiungi una nuova scheda',
	'defaultInfographicTitle': 'Infografica',

	'unsupportedConditionalFormattingEncountered': 'La formattazione condizionale non è più applicata per alcune colonne.',


	// Homepage View
	'nameColumn': 'Nome',
	'creatorColumn': 'Creato da',
	'creationDateColumn': 'Data di creazione',
	'versionColumn': 'Versione',
	'modifiedColumn': 'Ultima modifica',

	'filterBy': 'Filtra elementi',
	'allFilter': 'Tutti gli elementi',
	'createdByMeFilter': 'Creati da me',
	'sharedWithMeFilter': 'Condivisi con me',
	'favoritesFilter': 'Miei preferiti',
	'recentsFilter': 'Aggiunto di recente',
	'sortBy': 'Ordina per',

	// Sort Menu
	'sortModified': 'Modificato',
	'sortUpdated': 'Aggiornato',
	'sortName': 'Nome',

	'viewAs': 'Visualizza come',
	'thumbnailsView': 'Visualizza come anteprima',
	'listView': 'Visualizza come elenco',
	'createMenu': 'Crea',
	'newAppItem': 'Dashboard',
	'newDataSet': 'Dataset',

	'menuSelectionState_a11y': '"Selettore %{item}" impostato su "%{selectedItem}"',

	'unableToShareItem': 'Impossibile condividere l\'elemento "%{item}".',
	'toastFetchingContent': 'Richiamo altro contenuto in corso...',
	'unableToGetData': 'Impossibile richiamare il contenuto.',
	'unableToFavorite': 'Impossibile modificare lo stato Preferito.',
	'hpErrorMissingRequiredOptions': 'Opzioni di inizializzazione obbligatorie mancanti',
	'unableToOpenBoard': 'Impossibile aprire "%{name}".',
	'unableToDuplicateBoard': 'Impossibile duplicare "%{name}".',
	'unableToCreateBoard': 'Impossibile creare "%{name}".',
	'unableToCreateBoardNameConflict': 'Già esiste una risorsa con lo stesso nome.',

	// DataSet Detail View
	'status': 'Stato',
	'numberOfRows': 'Righe',
	'importWarnings': 'Avvertenze',
	'lineNumbers': 'Righe',
	'excerptFromSource': 'Estratto',
	'reason': 'Motivo',
	'numberOfRowsDropped': 'righe eliminate',
	'oneRowDropped': '1 riga è stata eliminata',

	// Type Menu
	'typeMenuLabel': 'Tipo',
	'dashboardsLabel': 'Dashboard',
	'datasetsLabel': 'Dataset',
	'storiesLabel': 'Storie',
	'allLabel': 'Tutti i tipi',

	// Board Page View App Bar
	'datasets': 'Dataset',
	'settings': 'Proprietà',
	'add': 'Aggiungi',
	'widgets': 'Widget',
	'dashboardProperties': 'Proprietà del dashboard',
	'searchPanel' : 'Ricerca',
	'pins': 'Raccolta',
	'pinsOld': 'Blocchi personali',
	'pinsDateFilterHeading' : 'Blocco data',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} pin |||| %{smart_count} pin',
	'pinSearch': 'Ricerca',
	'pinSearchOld': 'Ricerca blocchi',
	'pinListView': 'Vista elenco',
	'pinIconView': 'Vista icone',
	'pinRemove': 'Rimuovi',
	'pinCreate': 'Crea',
	'pinDeleteError': 'Impossibile eliminare una o più risorse dalla raccolta. Riprovare in seguito.',
	'pinDeleteErrorOld': 'Impossibile eliminare uno o più blocchi. Riprovare in seguito.',
	'pinRetrieveError': 'Impossibile recuperare uno o più blocchi. Riprovare in seguito.',
	'NoPinsCollected': 'Nessuna visualizzazione bloccata',
	'pinDeletedToast': 'Il blocco è stato rimosso',
	'pinRenamedToast': 'Il blocco è stato rinominato',
	'pinAddedToast': 'Il blocco è stato correttamente aggiunto a Blocchi personali',
	'pinningToast': 'Blocco elaborazione in corso...',
	'pinDateFilter': 'Filtro data',
	'pinDateFilterAll': 'Tutte',
	'pinDateFilterToday': 'Oggi',
	'pinDateFilterYesterday': 'Ieri',
	'pinDateFilterPastWeek': 'Settimana scorso',
	'pinDateFilterPastMonth': 'Mese scorso',
	'pinDateFilterEarlier': 'Precedente',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Modifica titolo',
	'toolbarActionSort': 'Ordinamento',
	'toolbarActionSortAscending': 'Ordine crescente',
	'toolbarActionSortDescending': 'Ordine decrescente',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionFormat': 'Formatta dati',
	'toolbarActionFormatAbbreviation': 'Abbrevia',
	'toolbarActionFormatNone': 'Automatico',
	'toolbarActionFilter': 'Filtro',
	'toolbarActionTopBottom': 'Primi elementi o ultimi elementi',
	'toolbarActionAddShape': 'Aggiungi forma',
	'toolbarActionRmvShape': 'Rimuovi forma',
	'toolbarActionToggleShapeDrop': 'Forma infografico',
	'toolbarActionToggleShapeDropTitle': 'Crea un infografico',
	'toolbarActionToggleShapeDropText': 'Trascinare la forma in questo campo per creare un infografico.',
	'toolbarActionAggregationType': 'Riepiloga',
	'toolbarDeleteActionText': 'Rimuovi colonna',
	'toolbarActionFilterLocalKeepSelected': 'Conserva',
	'toolbarActionFilterLocalExcludeSelected': 'Escludi',
	'toolbarActionFilterAllKeepSelected': 'Filtro',
	'toolbarActionSimpleCalculation': 'Calcoli semplici',
	'toolbarActionDrillBack': 'Indietro',
	'toolbarActionDrillUp': 'Drill up',
	'toolbarActionDrillDown': 'Drill down',
	'toolbarActionNavigate': 'Naviga',
	'toolbarActionCreateFilterGroup': 'Crea nuova connessione',
	'toolbarActionDisconnectFilterGroup': 'Interrompi tutti i collegamenti',
	'toolbarActionLinkFilterGroup': 'Aggiungi ad una connessione esistente',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Aggiungi',
	'sidebarMultiselect': 'Attiva/disattiva selezione multipla',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} selezionato',

	'multiselectWithTotalMsg': '%{count} di %{total}',
	'sidebarGoBack': 'Torna indietro',

	//DataSet pane
	'errorLoadingDataSets': 'Impossibile caricare questo dataset',
	'errorLoadingDataSetMetaData': 'Impossibile caricare questo dataset',
	'dataSetPaneLastUpdated': 'Ultimo aggiornamento: %{date}',
	'dataSetPaneDateUnknown': 'Sconosciuto',
	'sourcePaneLabel': 'Seleziona origini',
	'addSourceLabel': 'Aggiungi un\'origine',
	'find_label': 'Trova',
	'navigationPathsLabel': 'Percorsi di navigazione',

	//widgetlist
	'errorLoadingWidgetList': 'Impossibile caricare gli oggetti.',
	'errorLoadingThemeFile': 'Impossibile caricare la definizione del tema',
	'errorLoadingLayoutFile': 'Impossibile caricare la vista.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Impossibile caricare le definizioni di visualizzazione disponibili',

	'dwErrorLoadingVisualizationNotFound': 'Impossibile caricare l\'oggetto perché in esso manca una definizione di visualizzazione',
	'dwErrorLoadingVisualizationListNotFound': 'Impossibile caricare la visualizzazione.',
	'dwErrorRunningQuery': 'Non è possibile richiamare i dati dal dataset %{datasetName}.',
	'dwErrorGeoData': 'Si stanno verificando problemi durante la visualizzazione dei dati geografici nella mappa. Scegliere un altro tipo di visualizzazione. ',
	'dwPromptSignonCancelWarning': 'I dati di questa visualizzazione non sono disponibili. Fornire le credenziali corrette.',
	'dwErrorMissingDataset': 'Non è possibile caricare la visualizzazione, perché il suo dataset associato  \'%{datasetName}\' non è disponiibile.',
	'dwErrorRenderingVisualization': 'Impossibile caricare questa visualizzazione.',
	'dwErrorVisualizationTooSmall': 'La visualizzazione è troppo piccola per visualizzare i dati che contiene. Ingrandire la visualizzazione o limitare i dati che contiene.',
	'aria_label_datatable': 'Tabella dati',
	'aria_key_navi_datatable_desc': 'Utilizzare i tasti freccia per passare a ciascuna cella. Premere i tasti Control e Home per passare alla prima riga oppure i tasti Control e Fine per passare all\'ultima riga.',
	'geomapUnrecognizedLocations': 'Ubicazioni non riconosciute',
	'geomapAmbiguousLocations': 'Regioni ambigue:',

	// custom widget
	'customWidget': 'Widget personalizzato',
	'customWidgetsTitle': 'Widget personalizzati',
	'noCustomWidgets': 'Nessun widget personalizzato',

	// Action names
	'toggleContextBar': 'Attiva/disattiva la barra di contesto',
	'delete': 'Elimina',
	'share': 'Condividi',
	'unshare': 'Annulla condivisione',
	'rename': 'Ridenomina',
	'close': 'Chiudi',
	'duplicate': 'Duplica',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Riprova',

	'changeTemplate': 'Cambia modello',

	// Aggregation Types
	'sum': 'Somma',
	'count': 'Conteggio',
	'countdistinct': 'Conteggio distinto',
	'avg': 'Media',
	'min': 'Minimo',
	'max': 'Massimo',
	'custom': 'Personalizzato',
	'calculated': 'Calcolato',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% di modifiche',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Criteri di visualizzazione...',
	'QuickAddResultsHeader': 'Visualizzazioni dati',
	'NoQuickAddResults': 'Nessuna corrispondenza con lo scopo immesso. Creare un nuovo dataset?',
	'NoQuickAddResultsRetry': 'Impossibile trovare corrispondenze. Riprovare con termini diversi.',
	'templateWidgetTitle': 'Modello',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(vuoto)',

	'nullValueContent': '(nessun valore)',
	'nullValueText': 'Nullo',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Filtro testo - %{columnName}',

	'textFilterSelectTab': 'Seleziona',

	'textFilterConditionTab': 'Imposta una condizione',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Nessun elemento disponibile.',

	'textFilterEquals': 'Uguale a',
	'textFilterContains': 'Contiene',
	'textFilterBeginsWith': 'Inizia con',
	'textFilterEndsWith': 'Finisce con',
	'textFilterDoesNotEqual': 'Non uguale',
	'textFilterDoesNotContain': 'Non contiene',
	'textFilterDoesNotBeginWith': 'Non inizia con',
	'textFilterDoesNotEndWith': 'Non finisce con',
	'textFilterSampleText': 'Ad esempio: A',

	'textFilterAndButton': 'E',
	'textFilterOrButton': 'O',

	'dateFilterMessage': 'Seleziona un intervallo di date',
	'dateRangeControlRegionLabel': 'Filtro intervallo di date - %{columnName}',
	'dateFilterRangeOption': 'Opzioni intervallo',
	'dateFilterDateLabel': 'Data',
	'dateFilterBlank': '(vuoto)',
	'dateFilterBefore': 'Prima',
	'dateFilterAfter': 'Dopo',
	'dateFilterBetween': 'Tra',
	'dateFilterSampleText': 'AAAA-MM-GG',
	'dateTitle': 'Data',
	'dateIncludeBlankLabel': 'Includi data vuota',

	'timeTitle': 'Ora',
	'timeFilterMessage': 'Selezionare intervalli di tempo',
	'dateTimeFilterMessage': 'Seleziona un intervallo di date e ore',

	'topbottomNumberOfResultsLabel': 'Numero di risultati',
	'topbottomPercentLabel': 'Percentuale',
	'topbottomNumberOfResultsLimit': 'Compreso tra %{lower}-%{higher}',
	'topbottomSelectOption': 'Opzione primi elementi o ultimi elementi',
	'topbottomOptionLabel': 'Mostra',
	'searchByLabel': 'Per',
	'searchNoMatches': 'Nessuna corrispondenza trovata',
	'topbottomRankColumnLabel': 'Aggiungi una colonna di classifica alla tabella',
	'topbottomNone': 'Nessuna',
	'topCount': 'Numero massimo',
	'topPercent': '% massima',
	'bottomCount': 'Numero minimo',
	'bottomPercent': '% minima',
	'topbottomSearchColumn': 'Individuare una colonna',
	'searchColumnAriaLabel': 'Individuare una colonna. Immettere il nome della colonna in base alla quale effettuare la ricerca, quindi utilizzare la freccia in basso per trovare la colonna in un elenco',
	'rankColumnLabel': 'Classifica (%{columnLabel})',
	'topbottomClearLabel': 'Annulla',

	'rangeFilterControlRegionLabel': 'Filtro intervallo - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Controllo dispositivo di scorrimento, utilizzare le frecce destra e sinistra per spostare le barre del dispositivo di scorrimento.',
	'sliderHandleLabel': 'Barra del dispositivo di scorrimento',
	'a11ySliderHandleLabel': 'Barra del dispositivo di scorrimento %{sliderValue}',
	'sliderInputLabel': 'valore',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Alcuni elementi del dataset utilizzati in questa visualizzazione non sono disponibili.',
	'datasetItemUnavailable': 'Questo elemento del dataset non è disponibile',

	//Authoring topBottom
	'topOperator': 'In alto',
	'bottomOperator': 'In basso',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} per %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Solo questo oggetto',
	'deleteTopBottom': 'Elimina conteggio dei primi elementi o degli ultimi elementi',
	'editTopBottom': 'Modifica conteggio dei primi elementi o degli ultimi elementi',
	'deleteDrillState': 'Elimina lo stato di drill corrente',
	'ariaDeleteDrillStateLabel': 'Premere INVIO per modificare il conteggio dei primi elementi o degli ultimi elementi.',
	'drillUpStateTitle': 'Drill Up',
	'drillDownStateTitle': 'Drill Down',
	'ariaEditTopBottomLabel': 'Premere INVIO per modificare il conteggio dei primi elementi o degli ultimi elementi.',
	'ariaDeleteTopBottomLabel': 'Premere il tasto ELIMINA per eliminare il conteggio dei primi elementi o degli ultimi elementi.',

	// Authoring filtering
	'dimFilterIn': 'Include: %{in}',
	'dimFilterNotIn': 'Esclude: %{out}',
	'measureFilterBetween': 'Compreso tra %{lowerBound} e %{upperBound}',
	'measureFilterNotBetween': 'Non compreso tra %{lowerBound} e %{upperBound}',
	'gtFilter': 'Dopo %{lowerBound}',
	'ltFilter': 'Prima %{upperBound}',
	'notGtFilter': 'Non dopo %{lowerBound}',
	'notLtFilter': 'Non prima %{upperBound}',
	'localFilterTitle': 'Solo questo oggetto',
	'globalFilterTitle': 'Tutti gli oggetti',
	'deleteFilter': 'Elimina filtro',
	'editFilter': 'Modifica filtro',
	'ariaEditFilterLabel': 'Premere il tasto INVIO per modificare il filtro.',
	'ariaDeleteFilterLabel': 'Premere il tasto ELIMINA per eliminare il filtro.',

	// Prompts
	'ariaEditPrompt': 'Premere il tasto INVIO per modificare il valore di prompt',

	'moreDataIndicator': 'I dati sono stati ritagliati in %{threshold} elementi. Applicare un filtro per mostrarne di meno.',

	// data point filtering
	'dataPointFilterTitle': 'Punti dati',
	'dataPointFilterIncludeSummary': 'Inclusi %{valueCount} punti di dati',
	'dataPointFilterExcludeSummary': 'Esclusi %{valueCount} i punti dati',

	// DB2 connection page
	'db2Database': 'Database DB2 (%{jdbcConnection})',
	'db2Title': 'Connetti a IBM DB2',

	// Database
	'databaseConnectionMessage': 'Fornire i dettagli della connessione al database:',
	'connectionString': 'Stringa di connessione al database',
	'databaseCredentials': 'Credenziali: ',
	'databaseUserName': 'Nome utente',
	'databasePassword': 'Password',
	'databaseConnect': 'Connetti',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Immetti un termine di ricerca:',
	'twitterKeyword': 'Parola chiave',
	'twitterSearch': 'Ricerca',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'Non è possibile creare la vista: %{error}\nOperazione non riuscita: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Filtri del widget',
	'missingColumn': 'Mancante: %{columnLabel}',
	'missingFiltering': 'Filtri mancanti nei seguenti ID colonna:',
	'heatByLabel': 'Calore per',
	'evColumns': 'Colonne',
	'evLocalFilters': 'Filtri locali',
	'evExpand': 'Espandi',
	'evFilterTooltip': 'Filtro',
	'evAdd': 'Aggiungi una colonna',

	// Navigation View
	'navigationBack': 'Indietro',

	// Pinning
	'contentPinFail': 'Impossibile raccogliere il contenuto. Riprovare in seguito.',
	'contentPinFailOld': 'Impossibile bloccare il contenuto. Riprovare in seguito.',
	'pinRenameFail': 'Impossibile rinominare il blocco. Riprovare in seguito.',

	// Layouts
	'dropZoneLabel': 'Rilascia qui per ingrandire',

	//Share
	'shareDefaultPageTitle': 'Pagina %{index}',

	'nextPage': 'Pagina successiva',
	'previousPage': 'Pagina precedente',

	'assetAssembly': 'vista',

	'toolbar_save': 'Salva',
	'brgr_saveAs': 'Salva con nome',
	'brgr_refresh': 'Aggiorna',

	// Save
	'saving': 'Salvataggio in corso...',
	'save_success': 'La vista è stata salvata.',
	'save_failure': 'Spiacenti. La vista non può essere salvata. Riprovare più tardi.',
	'dashboard_save_success': 'Il dashboard è stato salvato.',

	'geminiLeave': 'Si sta per uscire da IBM Watson Analytics.',

	'warning': 'Avviso',
	'missingDataSetData': 'I dati per questo dataset non sono disponibili. Aggiornare il dataset o rivolgersi all\'amministratore per accedere all\'origine.',

	// Calculations
	'error_calculation_in_use': 'Il calcolo selezionato è in uso e non può essere eliminato.',

	'resize': 'Ridimensiona',
	'rotate': 'Ruota',
	'moveHandle': 'Sposta widget',
	'expandHandle': 'Espandi',
	'panHandle': 'Panoramica',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Passa a',

	// Slide out titles
	'shapeSlideoutTitle': 'Forme',
	'textSlideoutTitle': 'Testo',
	'mediaSlideoutTitle': 'Supporti',
	'visualizationSlideoutTitle': 'Visualizzazioni',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'Il JSON fornito non è valido. Consultare il log degli errori per ulteriori informazioni.',

	// Widget type labels
	'shape_label': 'Forma',
	'image_label': 'Immagine',
	'data_label': 'Grafico',
	'media_label': 'Supporti',
	'text_label': 'Testo',
	'embedMedia_label': 'Supporti',
	'youtube_label': 'Video YouTube',
	'webpage_label': 'Pagina Web',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Forma',
	'noExtraText_shape_numbered': 'Forma (%{number})',
	'few_shape': 'Gruppo di %{count} forme',
	'many_shape': 'Gruppo di %{count} forme',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': 'Immagine %{text} ',
	'one_image_numbered': '%{text} immagine (%{number})',
	'noExtraText_image': 'Immagine',
	'noExtraText_image_numbered': 'Immagine (%{number})',
	'few_image': 'Gruppo di %{count} immagini',
	'many_image': 'Gruppo di %{count} immagini',
	'noExtraText_text': 'Casella di testo vuota',
	'noExtraText_text_numbered': 'Casella di testo vuoto (%{number})',
	'few_text': 'Gruppo di %{count} caselle di testottext boxes',
	'many_text': 'Gruppo di %{count} caselle di testottext boxes',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Visualizzatore cubo',
	'pacubeviewer_named': 'Visualizzatore cubo %{name} ',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': 'Tabella incrociata %{values} per %{row_level1} e %{column_level1} ',
	'crosstab_opt_mapping_numbered': 'Tabella incrociata %{values} per %{row_level1} e %{column_level1} (%{number}) ',
	'crosstab_has_mapping': 'Tabella incrociata %{values} per %{row_level1} ',
	'crosstab_has_mapping_numbered': 'Tabella incrociata %{values} per %{row_level1} (%{number}) ',
	'crosstab_no_mapping': 'Tabella incrociata vuota',
	'crosstab_no_mapping_numbered': 'Tabella incrociata vuota (%{number})',
	'crosstab_named': '%{name} tabella incrociata',
	'crosstab_named_numbered': '%{name} tabella incrociata (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} tabella',
	'JQGrid_has_mapping_numbered': '%{grid_cols} tabella (%{number})',
	'JQGrid_no_mapping': 'Tabella vuota',
	'JQGrid_no_mapping_numbered': 'Tabella vuota (%{number})',
	'JQGrid_named': '%{name} tabella',
	'JQGrid_named_numbered': '%{name} tabella (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1} gerarchia',
	'hierarchy_has_mapping_numbered': '%{level1} gerarchia (%{number})',
	'hierarchy_no_mapping': 'Gerarchia vuota',
	'hierarchy_no_mapping_numbered': 'Gerarchia vuota (%{number})',
	'hierarchy_named': '%{name} gerarchia',
	'hierarchy_named_numbered': '%{name} gerarchia (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories} mappa',
	'map_has_mapping_numbered': '%{categories} mappa (%{number})',
	'map_no_mapping': 'Mappa vuota',
	'map_no_mapping_numbered': 'Mappa vuota (%{number})',
	'map_named': '%{name} mappa',
	'map_named_numbered': '%{name} mappa (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual} Valore di riepilogo ',
	'summary_has_mapping_numbered': '%{actual} valore di riepilogo (%{number})',
	'summary_no_mapping': 'Valore di riepilogo vuoto',
	'summary_no_mapping_numbered': 'Valore di riepilogo vuoto (%{number})',
	'summary_named': '%{name} valore di riepilogo ',
	'summary_named_numbered': '%{name} valore di riepilogo (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{actual} per %{sparkline.time} KPI',
	'kpi_opt_mapping_numbered': '%{actual} per %{sparkline.time} KPI (%{number})',
	'kpi_has_mapping': '%{actual} KPI',
	'kpi_has_mapping_numbered': '%{actual} KPI (%{number})',
	'kpi_no_mapping': 'KPI vuoto',
	'kpi_no_mapping_numbered': 'KPI vuoto (%{number})',
	'kpi_named': '%{name} KPI',
	'kpi_named_numbered': '%{name} KPI (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} infografica',
	'infographicSummary_has_mapping_numbered': '%{actual} infografica (%{number})',
	'infographicSummary_no_mapping': 'Infografica vuota',
	'infographicSummary_no_mapping_numbered': 'Infografica vuota (%{number})',
	'infographicSummary_named': '%{name} infografica',
	'infographicSummary_named_numbered': '%{name} infografica (%{number})',
	'noExtraText_youtube': 'Video YouTube',
	'noExtraText_youtube_numbered': 'Video YouTube (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} Video YouTube ',
	'one_youtube_numbered': '%{text} Video YouTube (%{number})',
	'few_youtube': 'Group of %{count} Videi YouTube ',
	'many_youtube': 'Group of %{count} Videi YouTube ',
	'noExtraText_embedMedia': 'Collegamento supporti',
	'noExtraText_embedMedia_numbered': 'Collegamento supporti (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text} collegamento supporti',
	'one_embedMedia_numbered': '%{text} collegamento supporti (%{number})',
	'few_embedMedia': 'Group of %{count} collegamento supporti',
	'many_embedMedia': 'Group of %{count} collegamenti supporti',
	'noExtraText_media': 'Supporti',
	'noExtraText_media_numbered': 'Supporti (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text} supporti',
	'one_media_numbered': '%{text} supporti (%{number})',
	'few_media': 'Group of %{count} supporti',
	'many_media': 'Group of %{count} supporti',
	'noExtraText_webpage': 'Pagina Web',
	'noExtraText_webpage_numbered': 'Pagina Web (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text} pagina web',
	'one_webpage_numbered': '%{text} pagina web (%{number})',
	'few_webpage': 'Group of %{count} pagine web',
	'many_webpage': 'Group of %{count} pagine web',
	'one_unknown': 'Un oggetto',
	'one_unknown_numbered': 'Un oggetto (%{number})',
	'few_unknown': 'Gruppo di %{count} oggetti',
	'many_unknown': 'Gruppo di %{count} oggetti',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Avanti',
	'previous': 'Indietro',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Il gruppo di navigazione corrente è %{navigation_group_name}',

	//Page Context
	'filterBlank': '(vuoto)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Impossibile caricare i valori filtro',
	'editTimelineHighlight': 'Modifica evidenziazione',

	'filterDockChevronLeft': 'Scorrere i dati',
	'filterDockChevronRight': 'Scorrere i dati',
	'expand': 'Espandi',
	'collapse': 'Comprimi',

	//Reset Dashboard
	'dashboardResetTitle': 'Reimposta dashboard',
	'dashboardResetMessage': 'Si è sicuri di voler annullare tutte le modifiche applicate al dashboard?',
	'dashboardResetToast': 'Il dashboard è stato reimpostato.',

	//Generate PDF
	'buildingPDF': 'Creazione PDF in corso...',
	'exportPDF': 'Esporta in PDF',
	'pageSize': 'Dimensione pagina',
	'orientation': 'Orientamento',
	'filtersPresentPDF': 'Filtri applicati alle visualizzazioni nella pagina precedente:',
	'errorPDF': 'Impossibile generare il PDF. Aggiornare e riprovare.',
	'errorPrintPDF': 'Impossibile generare il PDF. Riprovare.',
	'printPDFInfo': 'Visualizza documentazione',
	'pdfWidget': 'Widget',
	'includeFilters': 'Mostra dettagli filtro',
	'portrait': 'Verticale',
	'landscape': 'Orizzontale',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Il dashboard è stato aggiornato. Salvare ora per mantenere prestazioni ottimali.',

	'migratingDashboard': 'I dati del dashboard devono essere migrati; il dashboard verrà salvato quando la migrazione sarà stata completata...',
	'migrateDone': 'I dati del dashboard sono stati migrati.',
	'migrateNoPermission': 'È necessario migrare i dati del dashboard; ciò richiede l\'autorizzazione in scrittura; il rendering delle visualizzazioni verrà eseguito con un errore.',
	'migratingDataSourcesFailed': 'migrazione dei dati non riuscita per una o più origini dati',

	'ariaFullScreenMessage': 'Premere Esc per uscire dalla modalità a schermo intero',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} grafico a bolle di gerarchia compressa',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} grafico a bolle gerarchia compressa (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Grafico a bolle gerarchia compressa vuoto',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Grafico a bolle gerarchia compressa vuota (%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} grafico a bolle della gerarchia compressa',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} grafico a bolle gerarchia compressa (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{categories} per %{values} grafico marimekko ',
	'LIVE_marimekko_has_mapping_numbered': '%{categories} per %{values} grafico marimekko (%{number})',
	'LIVE_marimekko_no_mapping': 'Grafico marimekko vuoto',
	'LIVE_marimekko_no_mapping_numbered': 'Grafico marimekko vuoto (%{number})',
	'LIVE_marimekko_named': '%{name} grafico marimekko',
	'LIVE_marimekko_numbered': '%{name} grafico marimekko (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} grafico sunburst',
	'LIVE_sunburst_has_mapping_numbered': '%{values} grafico sunburst (%{number})',
	'LIVE_sunburst_no_mapping': 'Grafico radiale vuoto',
	'LIVE_sunburst_no_mapping_numbered': 'Grafico sunburst vuoto (%{number})',
	'LIVE_sunburst_named': '%{name} grafico sunburst ',
	'LIVE_sunburst_named_numbered': '%{name} grafico sunburst (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': '%{values} grafico analisi driver',
	'LIVE_decision_analysis_has_mapping_numbered': '%{values} grafico analisi driver (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Grafico analisi driver vuoto',
	'LIVE_decision_analysis_no_mapping_numbered': 'Grafico analisi driver vuoto (%{number})',
	'LIVE_decision_analysis_named': '%{name} grafico analisi driver',
	'LIVE_decision_analysis_named_numbered': '%{name} grafico analisi driver (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{categories} per %{columnValue} e %{lineValue} grafico a linee e colonne',
	'LIVE_line_column_opt_mapping_numbered': '%{categories} per %{columnValue} e %{lineValue} grafico a linee e colonne (%{number})',
	'LIVE_line_column_has_mapping': '%{columnValue} e %{lineValue} grafico a linee e colonne',
	'LIVE_line_column_has_mapping_numbered': '%{categories} per %{columnValue} e %{lineValue} grafico a linee e colonne (%{number})',
	'LIVE_line_column_no_mapping': 'Grafico a linee e colonne vuoto',
	'LIVE_line_column_no_mapping_numbered': 'Grafico a linee e colonne vuoto (%{number})',
	'LIVE_line_column_named': '%{name} grafico a linee e colonne',
	'LIVE_line_column_named_numbered' : '%{name} grafico a linee e colonne (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{x} per %{y} e %{size} grafico a bolle',
	'LIVE_bubble_chart_has_mapping_numbered': '%{x} per %{y} e %{size} grafico a bolle (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Grafico a bolle vuoto',
	'LIVE_bubble_chart_no_mapping_numbered': 'Grafico a bolle vuoto (%{number})',
	'LIVE_bubble_chart_named': '%{name} grafico a bolle',
	'LIVE_bubble_chart_named_numbered': '%{name} grafico a bolle (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual} grafico a punti elenco',
	'LIVE_bullet_has_mapping_numbered': '%{actual} grafico a punti elenco (%{number})',
	'LIVE_bullet_no_mapping': 'Grafico a punti elenco vuoto',
	'LIVE_bullet_no_mapping_numbered': 'Grafico a punti elenco vuoto (%{number})',
	'LIVE_bullet_named': '%{name} Grafico a punti elenco',
	'LIVE_bullet_named_numbered': '%{name} grafico a punti elenco (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'I dati in questo dashboard sono forniti da ',
	'showFooterToggleButtonText': 'Mostra piè di pagina ',
	'showFooterSectionText': 'Piè di pagina '

});
